module.exports = __webpack_public_path__ + "static/media/software_settings.5c9547af.svg";